import { render, staticRenderFns } from "./UploadhealthDocuments.vue?vue&type=template&id=9b3f5c8e&scoped=true&"
import script from "./UploadhealthDocuments.vue?vue&type=script&lang=js&"
export * from "./UploadhealthDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UploadhealthDocuments.vue?vue&type=style&index=0&id=9b3f5c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3f5c8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b3f5c8e')) {
      api.createRecord('9b3f5c8e', component.options)
    } else {
      api.reload('9b3f5c8e', component.options)
    }
    module.hot.accept("./UploadhealthDocuments.vue?vue&type=template&id=9b3f5c8e&scoped=true&", function () {
      api.rerender('9b3f5c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadFile/UploadhealthDocuments.vue"
export default component.exports